import { isString } from "../../validate"
import { isChineseInputText } from "./specialChecking"

export default ({ value: str }) => {
  if (!isString(str)) return false

  const maxCompanyNameLength = 50
  if (str.length <= 0 || str.length > maxCompanyNameLength) return false

  return isChineseInputText(str)
}
